<template>
    <v-select v-model="form.stage" v-bind="{ ...attrs_input, items, loading }" @input="update" />
</template>

<script>
import api from "@/api";
import { attrs_input, initApplication, RECRUITMENT_KANBAN_FIELDS } from "@/assets/variables";

let items = Object.values(RECRUITMENT_KANBAN_FIELDS).map((item) => ({
    text: item.text,
    value: item.stage,
}));

export default {
    props: {
        value: { type: Object, default: initApplication }, // application
    },
    data: () => ({
        form: initApplication(),

        attrs_input,
        items,
        loading: false,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initApplication(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
        async update() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { application } = await api.v1.company.recruitments.applications.putStage(this.form);
                this.$emit("updateItem", application);
            } finally {
                this.loading = false;
                this.search();
            }
        },
    },
};
</script>

<style></style>
